export const getValueByKey = (obj, key) => {
    const search = (obj, key) => {
        if (typeof obj === 'object' && obj !== null) {
            if (Array.isArray(obj)) {
                for (let i = 0; i < obj.length; i++) {
                    const result = search(obj[i], key);
                    if (result !== undefined) {
                        return result;
                    }
                }
            } else {
                for (let prop in obj) {
                    if (prop === key) {
                        return obj[prop];
                    } else {
                        const result = search(obj[prop], key);
                        if (result !== undefined) {
                            return result;
                        }
                    }
                }
            }
        }
    };

    return search(obj, key);
};
